FaqAutocompleteItemTemplate = require('../../autocompleteItem.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class FAQAutoCompleteItemView extends Backbone.View
  tagName: 'li'
  className: 'siblings'
  initialize: ->
    @I18nScope = 'modules.faq'
    @template = FaqAutocompleteItemTemplate

  render: (hash = {}) ->
    @$el.html toHtml(@template, @toHash(hash) , @I18nScope)
    @$el.attr("index","#{hash.index}")

  toHash : (hash) ->
    if hash?.item?.type?
      switch hash.item.type
        when 0 then hash.item.text = @highlightText(hash.keyword, hash.item.topic_text)
        when 1 then hash.item.text =  @highlightText(hash.keyword, hash.item.article_heading)
      return hash
    else
      return hash

  highlightText : (keyword ,text) ->
    if keyword? && text
      text = text.replace(/(<([^>]+)>)/ig,"")
      keywords = keyword.split(/\s+/)
      _.each(keywords, (word, index) ->
        unless (word is 'b' && index > 0)
          searchPattern = new RegExp('('+word+')', 'ig')
          text = text.replace(searchPattern , "<b>$1</b>" )
      )
      return text
    else
      return text

module.exports = FAQAutoCompleteItemView
